import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { firebaseConnect } from 'react-redux-firebase'
import moment from 'moment'

import { getTimeToTarget } from '../helpers'

class SaleBanner extends React.Component {
  componentDidMount() {
    const { storefront } = this.props

    this.countdown = setInterval(() => {
      const { days, hours, minutes, seconds } = getTimeToTarget(
        moment(storefront.featureExpirationTime)
      )

      if (days > 0 || hours > 0 || minutes > 0 || seconds > 0) {
        this.context.setBanner(
          `${
            storefront.feature.name
          } -- Expires in ${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`
        )
      } else {
        this.context.clearBanner()
        clearInterval(this.countdown)
      }
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.countdown)
  }

  render() {
    const { children, ...props } = this.props
    return React.cloneElement(children, props)
  }
}

SaleBanner.contextTypes = {
  setBanner: PropTypes.func,
}

const watches = ({ storefront }) => []

const selectors = createStructuredSelector({})

const actions = (dispatch, props) => ({})

export default compose(firebaseConnect(watches), connect(selectors, actions))(
  SaleBanner
)



// WEBPACK FOOTER //
// ./src/screens/SaleBanner.js